/**
 * LA PORTE DES ROUTES DU MODULE.
 * ============================================================================
 *
 * Un `beforeEnter` asynchrone qui ATTEND la lecture de la garde serveur avant
 * de juger : un rechargement ou un signet sur une page du module juge donc sur
 * une lecture faite, jamais sur l'état « fermé par défaut » d'un store pas
 * encore lu.
 *  • fermé : retour à l'accueil, sans message (le module n'existe pas pour ce
 *    compte) ;
 *  • ouvert : la navigation continue, même si l'offre n'a pas pu être lue
 *    (les gestes restent alors absents) ; une offre non lue est relue à
 *    chaque entrée sur une page du module, jamais ailleurs.
 * La porte ne rend aucun composant : l'écran hors offre est rendu par la page,
 * dans `CadreModule`.
 */
import type { RouteLocationRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { useOuvertureStore } from "@modules/alarmes-v2/stores/ouverture.store"

/** Juge l'entrée sur une page du module. */
export async function porteAlarmesV2(): Promise<true | RouteLocationRaw> {
    const auth = useAuthStore()
    // La garde globale lit déjà l'utilisateur ; par prudence, pas de jugement sans lui.
    if (auth.isLogged && !auth.userId) {
        try {
            await auth.fetchUser()
        } catch {
            // Utilisateur illisible : la lecture ci-dessous reste fermée.
        }
    }
    const ouverture = useOuvertureStore()
    await ouverture.charger({ relireOffre: true })
    return ouverture.ouvert ? true : { name: "Home" }
}
